module.exports = __webpack_public_path__ + "img/东海鲳鱼渔场预报系统.e18df7fd.png";